import { useLocation, useNavigate } from 'react-router-dom'
import { Button, XStack } from 'tamagui'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import { useChannelList } from '../hooks/useChannelList'
import { CobuStack, CobuButton } from '@cobu/ui'
import Bubble from '../assets/icons/Bubble'
import { useFeatureFlags } from '../hooks/useFeatureFlags'

export default function TopHeaderRight() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { isStreamAvailable } = useChannelList({ enabled: false })
  const { showDM } = useFeatureFlags()

  return (
    <CobuStack w={80} jc="flex-end" layout="horizontal" gap="$3" pr="$2">
        <>
          <CobuButton
            dsVariant="ghost"
            backgroundColor="transparent"
            p="$0"
            py="$0"
            height={('$7' as any)}
            onPress={() => navigate('/notifications')}
          >
            <NotificationsNoneOutlinedIcon fontSize="small" />
          </CobuButton>
          {showDM && (
          <CobuButton
            dsVariant="ghost"
            backgroundColor="transparent"
            p="$1"
            py="$0"
            height={('$7' as any)}
            onPress={() => navigate('/chat/channels')}
          >
            <Bubble size={20} color="currentColor" />
          </CobuButton>
          )}
        </>
    </CobuStack>
  )
}


